/**
 * Method that takes id of element and positions it top left of viewPort
 * @param elemName id of the html element
 * @returns Void
 */
export function positionPage(elemName: string) {
  let elem = document.getElementById(elemName);

  if (elem) {
    let domRect = elem?.getBoundingClientRect();
    elem.style.top = `-${domRect.y}px`;
    elem.style.left = `-${domRect.x}px`;
  }
}
